/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_OverlineInputs */

const en_mk_parts_overline = /** @type {(inputs: Mk_Parts_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The shape of the product`)
};

const id_mk_parts_overline = /** @type {(inputs: Mk_Parts_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bentuk produknya`)
};

/**
* | output |
* | --- |
* | "The shape of the product" |
*
* @param {Mk_Parts_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_overline = /** @type {((inputs?: Mk_Parts_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_overline(inputs)
	return en_mk_parts_overline(inputs)
});